import * as auth from "./auth";
import * as ui from "./ui";

export default {auth, ui};

